import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "api";

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });
export const purchaseTicketApi = createApi({
  reducerPath: "purchaseTicketApi",
  baseQuery: baseQueryWithRetry,
  keepUnusedDataFor: 60 * 5,
  endpoints: (build) => ({
    purchaseTicket: build.mutation({
      query: (credentials) => {
        return {
          url: `/purchased-tickets`,
          method: "POST",
          body: {
            ticket_id: credentials.ticket_id,
            lottery_count: 1,
          },
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const { usePurchaseTicketMutation } = purchaseTicketApi;
